<template>
  <div class="select-person">
    <div class="select-person-list">
      <person-item bordered :person="item" v-for="(item, i) in selected" :key="item.id">
        <a-icon type="close" class="person-operate" @click="removeSelect(i)"/>
      </person-item>
      <person-picker
        show-tel
        :multiple="multiple"
        :url="url"
        :title="title"
        :query="query"
        :unique-key="uniqueKey"
        :value="selected"
        @change="handleSelect">
        <a-tooltip>
          <template slot="title">{{ title }}</template>
          <a-button size="small" shape="circle" type="primary" icon="plus"/>
        </a-tooltip>
      </person-picker>
    </div>
  </div>
</template>

<script>
    import personPicker from "./person-picker";
    import personItem from "../person-item";
    import {isArray} from "../../common/js/tool";
    export default {
        name: "selectPerson",
        model: {
            event: "change"
        },
        components: {
            personItem,
            personPicker
        },
        props: {
            type: Number,
            activity: Number,
            uniqueKey: String,
            title: {
                type: String,
                default: '选择成员'
            },
            guest: Boolean, // 是否是选择嘉宾
            multiple: Boolean,
            value: [Object, Array]
        },
        data() {
            return {
            }
        },
        computed: {
            url() {
                return this.guest ? '/activity/activity-guest' : '/activity/activity-receptionist'
            },
            selected() {
                const value = this.value;
                let res = [];
                if(value) {
                    if(isArray(value)) {
                        res = value;
                    } else {
                        res = [value]
                    }
                }
                return res;
            },
            query() {
                let res = '';
                const type = this.type;
                const activity = this.activity;
                if(type) {
                    res += `&filter[type]=${type}`;
                }
                if(activity) {
                    // 工作人员同时可以选择内部人员
                    if(type == 2) {
                        res = (keyword) => {
                            let q = '&filter[type]=2';
                            if(keyword) {
                                [activity, 0].forEach((id, i) => {
                                    const arr = ['name', 'tel'];
                                    const len = arr.length;
                                    arr.forEach((str, j) => {
                                        const index = i * len + j;
                                        q += `&filter[or][${index}][activity_id]=${id}&filter[or][${index}][${str}][like]=${keyword}`;
                                    });
                                })
                            } else {
                                q += `&filter[or][0][activity_id]=${activity}&filter[or][1][activity_id]=0`;
                            }
                            return q;
                        }
                    } else {
                        res += `&filter[activity_id]=${activity}`;
                    }
                }
                return res;
            }
        },
        methods: {
            removeSelect(i) {
                const list = [...this.selected];
                list.splice(i, 1);
                this.$emit("change", list.length > 0 ? (this.multiple ? list : list[0]) : null);
            },
            handleSelect(select) {
                select = select || [];
                this.$emit("change", select.length > 0 ? (this.multiple ? select : select[0]) : null);
                this.visible = false;
            },
        }
    }
</script>

<style lang="less">
  .select-person-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .person-item {
      margin-right: 0.5em;
    }
  }
</style>
